module.exports = __webpack_public_path__ + "static/img/d-coupons.f0268419.png";